import React from "react";
import Hero from "../components/Hero";
import PowerSection from "../components/PowerSection";
import WhatWeDo from "../components/WhatWeDo";
import MediaFinder from "../components/MediaFinder";
import LogoMarquee from "../components/LogoMarquee";
import CaseStudies from "../components/CaseStudies";
import Services from "../components/Services";
import Founders from "../components/Founders";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <main>
      <Hero />
      <PowerSection />
      <WhatWeDo />
      <LogoMarquee />
      <MediaFinder />
      <Services />
      <CaseStudies />
      <Founders />
      <Testimonials />
    </main>
  );
};

export default Home;
